<div class="task-manager-overlay-container mat-elevation-z15 history-container">
  <app-task-manager [data]="data" (close)="onClose($event)"></app-task-manager>
</div>
